import * as React from 'react'
import { minutesToTime } from '../helpers/time'

type WorktypeShape = {
  category?: string
  code?: string
  title?: string
}

type EntryTime = {
  id: number
  time: number
  worktype?: WorktypeShape
  comment?: string
}

type EntryItemProps = {
  jobTitle: string
  times: EntryTime[]
  footer?: React.ReactNode
  timeColumnClassName?: string
  inlineEditButton?: React.ReactNode
}

function calculateTimeTotals(times: EntryTime[]) {
  let timeTotal = 0
  let overtimeTotal = 0
  let supplementTotal = 0

  times.forEach(time => {
    const category = time.worktype?.category
    if (category === 'overtime') {
      overtimeTotal += time.time
    } else if (category === 'supplement') {
      supplementTotal += time.time
    } else {
      timeTotal += time.time
    }
  })

  return { timeTotal, overtimeTotal, supplementTotal }
}

function formatTimeRecord(time: EntryTime): string {
  const formatted = minutesToTime(time.time)
  const category = time.worktype?.category
  let decorated = formatted

  if (category === 'overtime') {
    decorated = `(${formatted})`
  } else if (category === 'supplement') {
    decorated = `[${formatted}]`
  }

  let result = `${decorated} | ${time.worktype?.code} - ${time.worktype?.title}`
  if (time.comment) {
    result += ` | ${time.comment}`
  }

  return result
}

export default function EntryItem({ jobTitle, times, footer, timeColumnClassName = 'col-12', inlineEditButton }: EntryItemProps) {
  const { timeTotal, overtimeTotal, supplementTotal } = React.useMemo(() => calculateTimeTotals(times), [times])

  return (
    <div className="row">
      <div className="col-3 time-col">
        <div className="d-flex flex-column" style={{ height: '100%' }}>
          <div>
            {timeTotal > 0 && <div>{minutesToTime(timeTotal)}</div>}
            {overtimeTotal > 0 && <div className="overtime">({minutesToTime(overtimeTotal)})</div>}
            {supplementTotal > 0 && <div className="overtime">[{minutesToTime(supplementTotal)}]</div>}
          </div>
          {inlineEditButton && (
            <div>
              {inlineEditButton}
            </div>
          )}
        </div>
      </div>
      <div className="col-9 time-content">
        <div className="row time-title">
          <div className="col-12">
            {jobTitle}
          </div>
        </div>
        <div className="row">
          {times.map(time => (
            <div key={time.id} className={timeColumnClassName}>
              {formatTimeRecord(time)}
            </div>
          ))}
        </div>
        {footer}
      </div>
    </div>
  )
}

